import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import "./assets/css/custom.css";
import App from "./app";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";

const rootElement = document.getElementById("root");
const initialAuth = window.__SEVENLY_INITIAL_AUTH__ || null;
const app = <App initialAuth={initialAuth} />;

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}

reportWebVitals();
